export default function Error() {
  return <div>Sedang terjadi masalah pada sistem</div>;
}
